// src/App.jsx

import React, { useState, useEffect, useContext } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

/* ================= PAGES ================= */

import Login from "./pages/login";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Android from "./pages/android";
import Ios from "./pages/ios";
import WebApp from "./pages/webapp";
import GraphicDesign from "./pages/GraphicDesign";
import SocialMediaMarketing from "./pages/SocialMediaMarketing";
import Client from "./pages/Client";

import OurProjects from "./pages/ourprojects";
import CaseStudy from "./pages/casestudy";
import Testimonials from "./pages/test";
import UIUX from "./pages/uiux";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Dashboard from "./pages/dashboard";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import CustomerDashboard from "./pages/CustomerDashboard";
import MarketingDashboard from "./pages/MarketingDashboard";
import SalesDashboard from "./pages/SalesDashboard";
import Attendance from "./pages/attendance";
import CustomerQueries from "./pages/CustomerQueries";
import ApplyLeave from "./pages/ApplyLeave";
import AdminProjects from "./pages/Adminprojects";
import LeaveRequests from "./pages/LeaveRequests";
import Buy from "./pages/Buy";
import Sell from "./pages/Sell";

/* ================= COMPONENTS ================= */

import UserNavbar from "./pages/UserNavbar";
import AdminNavbar from "./pages/adminnav";
import Footer from "./pages/footer";
import QueryForm from "./pages/QueryForm";
import ProtectedRoute from "./pages/ProtectedRoute";
import AnimatedBackground from "./pages/AnimatedBackground";

/* ================= AUTH ================= */

import { AuthContext } from "./pages/AuthContext";

/* ================= APP ================= */

function App() {
  const { isAuthenticated, role, logout } = useContext(AuthContext);

  const [showQueryForm, setShowQueryForm] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  /* ================= AUTO REDIRECT IF NOT AUTHENTICATED ================= */

  // useEffect(() => {
  //   if (!isAuthenticated && location.pathname.startsWith("/pages")) {
  //     navigate("/login");
  //   }
  // }, [isAuthenticated, location.pathname, navigate]);

  /* ================= QUERY WIDGET ================= */

  const showQueryWidget = !isAuthenticated && location.pathname !== "/login";

  /* ================= RENDER ================= */

  return (
    <>
      <AnimatedBackground />

      {/* NAVBAR SWITCH */}
      {isAuthenticated ? (
        <AdminNavbar handleLogout={logout} role={role} />
      ) : (
        <UserNavbar />
      )}

      {/* MAIN CONTENT */}
      <div style={{ minHeight: "100vh" }}>
        <Routes>
          {/* ================= PUBLIC ROUTES ================= */}
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pages" element={<Portfolio />} />
          <Route path="/android" element={<Android />} />
          <Route path="/ios" element={<Ios />} />
          <Route path="/webapp" element={<WebApp />} />
          <Route path="/pages/projects" element={<OurProjects />} />
          <Route path="/pages/case-studies" element={<CaseStudy />} />
          <Route path="/pages/testimonials" element={<Testimonials />} />
          <Route path="/uiux" element={<UIUX />} />
          <Route path="/GraphicDesign" element={<GraphicDesign />} />
          <Route
            path="/SocialMediaMarketing"
            element={<SocialMediaMarketing />}
          />
          <Route path="/pages/career" element={<Careers />} />
          <Route path="/pages/contact" element={<Contact />} />
          <Route path="/pages/buy" element={<Buy />} />
          <Route path="/pages/sell" element={<Sell />} />

          {/* ================= LOGIN ================= */}
          <Route path="/login" element={<Login />} />

          {/* ================= APPLY LEAVE ================= */}
          <Route
            path="/pages/apply-leave"
            element={
              <ProtectedRoute
                allowedRoles={["Sales", "Marketing", "Employee", "Customer"]}
              >
                <ApplyLeave />
              </ProtectedRoute>
            }
          />

          {/* ================= ADMIN / MANAGER ================= */}
          <Route
            path="/pages/dashboard"
            element={
              <ProtectedRoute allowedRoles={["Admin", "Manager"]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pages/leave-requests"
            element={
              <ProtectedRoute allowedRoles={["Admin", "Manager"]}>
                <LeaveRequests />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pages/admin/projects"
            element={
              <ProtectedRoute allowedRoles={["Admin", "Manager"]}>
                <AdminProjects />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pages/client"
            element={
              <ProtectedRoute allowedRoles={["Admin", "Manager"]}>
                <Client />
              </ProtectedRoute>
            }
          />

          {/* ================= SHARED ATTENDANCE ================= */}
          <Route
            path="/pages/attendance"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "Admin",
                  "Manager",
                  "Sales",
                  "Marketing",
                  "Employee",
                  "Customer",
                ]}
              >
                <Attendance />
              </ProtectedRoute>
            }
          />

          {/* ================= ROLE DASHBOARDS ================= */}
          <Route
            path="/pages/sales-dashboard"
            element={
              <ProtectedRoute allowedRoles={["Sales"]}>
                <SalesDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pages/marketing-dashboard"
            element={
              <ProtectedRoute allowedRoles={["Marketing"]}>
                <MarketingDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pages/employee-dashboard"
            element={
              <ProtectedRoute allowedRoles={["Employee"]}>
                <EmployeeDashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pages/customer-dashboard"
            element={
              <ProtectedRoute allowedRoles={["Customer"]}>
                <CustomerDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>

      <Footer />

      {/* QUERY WIDGET (ONLY MAIN WEBSITE) */}
      {showQueryWidget && (
        <QueryForm open={showQueryForm} setOpen={setShowQueryForm} />
      )}
    </>
  );
}

export default App;
